import { __assign } from 'tslib';
import * as React from 'react';
import { UitkIcon } from 'uitk-react-icons';
import { classNames } from 'uitk-react-utils';
import { UitkTriggerPill } from './uitk-trigger-pill.esm.js';
import styles from './uitk-pill.css';

var getClassNameList = classNames.bind(styles);
var UitkPill = function (props) {
    var _a, _b;
    var active = props.active, altText = props.altText, children = props.children, checked = props.checked, className = props.className, disabled = props.disabled, icon = props.icon, id = props.id, name = props.name, onChange = props.onChange, onClick = props.onClick, selected = props.selected, triggerPill = props.triggerPill, toggleState = props.toggleState, value = props.value, domRef = props.domRef;
    var triggerPillProps = {
        active: active,
        children: children,
        className: className,
        disabled: disabled,
        icon: icon,
        id: id,
        name: name,
        onClick: onClick,
        selected: selected,
        toggleState: toggleState,
        domRef: domRef
    };
    var baseClassName = 'uitk-pill';
    var wrapperClassName = getClassNameList(baseClassName, className, (_a = {},
        _a["".concat(baseClassName, "-disabled")] = disabled,
        _a));
    var pillContentClassName = getClassNameList("".concat(baseClassName, "-content"), (_b = {},
        _b["".concat(baseClassName, "-active")] = active,
        _b["".concat(baseClassName, "-selected")] = selected,
        _b));
    var inputValue = value !== null && value !== void 0 ? value : "".concat(checked);
    return triggerPill ? (React.createElement(UitkTriggerPill, __assign({}, triggerPillProps))) : (React.createElement("div", { className: wrapperClassName },
        React.createElement("input", { id: id, name: name, checked: checked, "aria-checked": checked, type: "checkbox", onChange: onChange, className: getClassNameList("".concat(baseClassName, "-standard is-visually-hidden")), disabled: disabled, value: inputValue }),
        React.createElement("label", { className: pillContentClassName, htmlFor: id, "aria-label": altText },
            icon && React.createElement(UitkIcon, { className: getClassNameList("".concat(baseClassName, "-icon")), name: icon }),
            React.createElement("span", { className: getClassNameList("".concat(baseClassName, "-text")) }, children))));
};
UitkPill.defaultProps = {
    checked: false
};
UitkPill.displayName = 'UitkPill';

export { UitkPill };
